<template>
    <div :class="['custom-work-executive-picker', { 'manual-entry-active': manualEntryActive }]">
        <CustomWorkOption :option="selectedPackage" />
        <div class="active-pane">
            <EntityAutocomplete ref="autocomplete" :entityTypes="['Executive']" :limit="1000" @autocomplete="add">
                <template #static-option-append="props">
                    <div class="more-results-link primary-link" @click="showManualEntry(props.searchText)">
                        Pick Your Own
                    </div>
                </template>
            </EntityAutocomplete>
            <CustomWorkExecutiveEntry
                v-if="manualEntryActive"
                @cancel="cancelManualEntry"
                @commit="commitManualEntry"
                :initialName="manualEntryName"
            />
            <CustomWorkExecutivesList :executives="modelValue" @remove="remove" editable />
        </div>
    </div>
</template>
<script>
import CustomWorkExecutivesList from './CustomWorkExecutivesList'
import CustomWorkExecutiveEntry from './CustomWorkExecutiveEntry'
import CustomWorkOption from './CustomWorkOption'
import EntityAutocomplete from '@/components/Search/EntityAutocomplete.vue'

export default {
    components: {
        EntityAutocomplete,
        CustomWorkExecutiveEntry,
        CustomWorkExecutivesList,
        CustomWorkOption,
    },
    model: {
        prop: 'modelValue',
        event: 'update:modelValue',
    },
    data() {
        return {
            manualEntryActive: false,
            manualEntryName: '',
        }
    },
    props: {
        modelValue: {
            type: Array,
            required: true,
        },
        selectedPackage: {
            type: Object,
            required: true,
        },
    },
    methods: {
        add(executive) {
            const executives = this.modelValue.slice(0)

            if (!executives.find(e => e.id === executive.id)) {
                executives.push(executive)
                this.$emit('update:modelValue', executives)
            }
        },
        commitManualEntry(executive) {
            const executives = this.modelValue.slice(0)

            executives.push(executive)
            this.$emit('update:modelValue', executives)

            this.manualEntryActive = false
            this.$refs.autocomplete.clear()
        },
        cancelManualEntry() {
            this.manualEntryActive = false
            this.$refs.autocomplete.focus()
        },
        remove(executive) {
            const executives = this.modelValue.slice(0)
            executives.splice(executives.indexOf(executive), 1)
            this.$emit('update:modelValue', executives)
        },
        showManualEntry(searchText) {
            this.$refs.autocomplete.blur()
            this.manualEntryActive = true
            this.manualEntryName = searchText.trim()
        },
    },
}
</script>
<style>
.custom-work-executive-picker {
    display: flex;
    flex-grow: 1;
    height: 1%;
    gap: 40px;
    align-items: stretch;
    justify-items: stretch;
    z-index: 1;

    & > * {
        width: 50%;
    }

    .custom-work-option {
        border: 1px solid var(--color-dark);

        button {
            display: none;
        }
    }

    .active-pane {
        display: flex;
        flex-direction: column;
        height: 100%;
        position: relative;
        z-index: 1;

        .search-input-absolute {
            max-height: 384px;
            overflow-y: auto;
        }

        .more-results-link:first-child {
            padding: 8px;
        }
    }

    .custom-work-executive-entry {
        background-color: white;
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
    }

    &.manual-entry-active + .footer .button-group {
        display: none;
    }
}
</style>
